import {
  Clock,
  ExternalLink,
  Luggage,
  Mail,
  QrCode,
  ShoppingCart,
  X,
  XCircle,
  Zap,
} from 'lucide-react';
import {VelaScene, type VelaRule} from '../engine/types';

export const upsellingRules: VelaRule[] = [
  {
    id: 'upselling/instant-lane',
    section: 'twoWaysToBook',
    scenes: [VelaScene.Upselling],
    priority: 30,
    evaluate: (_, t) => ({
      id: 'instant-lane',
      icon: <Zap />,
      title: t('card.instant_lane.title'),
      description: t('card.instant_lane.body'),
    }),
  },
  {
    id: 'upselling/on-request-lane',
    section: 'twoWaysToBook',
    scenes: [VelaScene.Upselling],
    priority: 20,
    evaluate: (_, t) => ({
      id: 'on-request-lane',
      icon: <Clock />,
      title: t('card.on_request_lane.title'),
      description: t('card.on_request_lane.body_authorised'),
      tone: 'warning',
    }),
  },
  {
    id: 'upselling/partner-offers',
    section: 'twoWaysToBook',
    scenes: [VelaScene.Upselling],
    priority: 10,
    evaluate: (_, t) => ({
      id: 'partner-offers',
      icon: <ExternalLink />,
      title: t('card.partner_offers.title'),
      description: t('card.partner_offers.body'),
    }),
  },
  {
    id: 'upselling/when-am-i-charged',
    section: 'goodToKnow',
    scenes: [VelaScene.UpsellingOffer],
    priority: 30,
    evaluate: (ctx, t) => ({
      id: 'when-am-i-charged',
      icon: ctx.upsell.isOnRequest ? <Clock /> : <ShoppingCart />,
      title: t('card.when_am_i_charged_for_an_extra.title'),
      description: ctx.upsell.isOnRequest
        ? t('card.when_am_i_charged_for_an_extra.body_on_request_authorised')
        : t('card.when_am_i_charged_for_an_extra.body_instant'),
    }),
  },
  {
    id: 'upselling/changed-your-mind',
    section: 'goodToKnow',
    scenes: [VelaScene.UpsellingOffer],
    priority: 20,
    evaluate: (ctx, t) => ({
      id: 'changed-your-mind',
      icon: <XCircle />,
      title: t('card.changed_your_mind_about_an_extra.title'),
      description: ctx.upsell.isOnRequest
        ? t('card.changed_your_mind_about_an_extra.body_on_request_authorised')
        : t('card.changed_your_mind_about_an_extra.body_instant'),
    }),
  },
  {
    id: 'upselling/you-will-get-an-email',
    section: 'goodToKnow',
    scenes: [VelaScene.UpsellingOffer],
    priority: 10,
    evaluate: (ctx, t) =>
      ctx.upsell.isOnRequest
        ? {
            id: 'you-will-get-an-email',
            icon: <Mail />,
            title: t('card.you_will_get_an_email.title'),
            description: t('card.you_will_get_an_email.body'),
          }
        : null,
  },
  {
    id: 'upselling/luggage-book-and-pay',
    section: 'goodToKnow',
    scenes: [VelaScene.UpsellingOffer],
    priority: 9,
    evaluate: (ctx, t) =>
      ctx.upsell.isLuggage
        ? {
            id: 'luggage-book-and-pay',
            icon: <Luggage />,
            title: t('card.luggage_book_and_pay.title'),
            description: t('card.luggage_book_and_pay.body'),
          }
        : null,
  },
  {
    id: 'upselling/luggage-one-qr',
    section: 'goodToKnow',
    scenes: [VelaScene.UpsellingOffer],
    priority: 8,
    evaluate: (ctx, t) =>
      ctx.upsell.isLuggage
        ? {
            id: 'luggage-one-qr',
            icon: <QrCode />,
            title: t('card.luggage_one_qr.title'),
            description: t('card.luggage_one_qr.body'),
          }
        : null,
  },
  {
    id: 'upselling/luggage-hours',
    section: 'goodToKnow',
    scenes: [VelaScene.UpsellingOffer],
    priority: 7,
    evaluate: (ctx, t) =>
      ctx.upsell.isLuggage && ctx.upsell.hasStorage
        ? {
            id: 'luggage-hours',
            icon: <Clock />,
            title: t('card.luggage_check_hours.title'),
            description: t('card.luggage_check_hours.body'),
          }
        : null,
  },
  {
    id: 'upselling/status-waiting',
    section: 'requestStatuses',
    scenes: [VelaScene.UpsellingRequests],
    priority: 30,
    evaluate: (_, t) => ({
      id: 'status-waiting',
      icon: <Clock />,
      title: t('card.status_waiting.title'),
      description: t('card.status_waiting.body'),
      tone: 'warning',
    }),
  },
  {
    id: 'upselling/status-in-cart',
    section: 'requestStatuses',
    scenes: [VelaScene.UpsellingRequests],
    priority: 20,
    evaluate: (_, t) => ({
      id: 'status-in-cart',
      icon: <ShoppingCart />,
      title: t('card.status_in_your_cart.title'),
      description: t('card.status_in_your_cart.body'),
    }),
  },
  {
    id: 'upselling/status-declined',
    section: 'requestStatuses',
    scenes: [VelaScene.UpsellingRequests],
    priority: 10,
    evaluate: (_, t) => ({
      id: 'status-declined',
      icon: <X />,
      title: t('card.status_declined.title'),
      description: t('card.status_declined.body'),
      tone: 'danger',
    }),
  },
];
